import { useIntl } from 'react-intl';
import { useToast } from '../../../../../../modules/components/toast/ToastContext';
import { SiService } from '../../../../mappings';
import KeywordTypeBadge from '../../../../../../modules/components/badge/KeywordTypeBadge';
import clsx from 'clsx';
import ToggleSwitch from '../../../../../../modules/components/toggleSwitch/ToggleSwitch';
import { getCardId } from './CategoryDetail';
import { UsePageDataManagerResult } from '../../hooks/usePageDataManager';

interface Props {
  data: any;
  status: string;
  refetch: () => void;
  isEditable?: boolean;
  isSiAiNewData?: boolean;
  onUpdate?: UsePageDataManagerResult['updateField'];
}

export default function MembersOnlyContent({
  data,
  status,
  refetch,
  isEditable,
  isSiAiNewData,
  onUpdate,
}: Props) {
  const intl = useIntl();
  const t = (id: string, values?: Record<string, string | number>) =>
    intl.formatMessage({ id: `SI_CATEGORY_DETAIL.${id}` }, values);
  const { setToast } = useToast();
  const emDash = '—';
  const shouldRenderSiAiReadonlyStyle = !isEditable && !!isSiAiNewData;

  const isMembersOnly = data?.result?.members_only ?? false;

  if (shouldRenderSiAiReadonlyStyle) {
    return (
      <>
        <div
          className={clsx('card border', !isMembersOnly && 'opacity-50')}
          id={getCardId(SiService.MEMBERS_ONLY_SIFT_SERVICE)}
          style={{ scrollMarginTop: '9.75rem', scrollBehavior: 'smooth' }}
        >
          <div className='card-body p-6'>
            <div className='d-flex align-items-start gap-3'>
              <i className='bi bi-tag-fill text-warning fs-4 mt-1'></i>
              <div className='d-flex flex-column gap-2'>
                <div className='fw-bolder'>
                  {intl.formatMessage({ id: `SI_KEYWORD_TYPE_BADGE.${SiService.MEMBERS_ONLY_SIFT_SERVICE}` })}
                </div>
                {/* <div>{data?.result?.members_only_reason ?? emDash}</div> */}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <div
        className={clsx('card border', !isMembersOnly && 'opacity-50')}
        id={getCardId(SiService.MEMBERS_ONLY_SIFT_SERVICE)}
        style={{ scrollMarginTop: '9.75rem', scrollBehavior: 'smooth' }}
      >
        {isEditable ? (
          <div className='card-header px-6 border-0'>
            <h4 className='card-title gap-4'>
              <KeywordTypeBadge
                type={SiService.MEMBERS_ONLY_SIFT_SERVICE}
                className={clsx('fs-base', !isMembersOnly && 'opacity-50')}
              />
              <ToggleSwitch
                isVisible={isMembersOnly}
                onToggle={() => {
                  onUpdate(
                    SiService.MEMBERS_ONLY_SIFT_SERVICE,
                    'result.members_only',
                    !isMembersOnly
                  );
                }}
              />
            </h4>
          </div>
        ) : (
          <div className='card-body p-3 d-flex justify-content-end'>
            <KeywordTypeBadge
              type={SiService.MEMBERS_ONLY_SIFT_SERVICE}
              className={clsx('fs-8', !isMembersOnly && 'opacity-50')}
            />
          </div>
        )}
      </div>
    </>
  );
}
